/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_294ebbed"]'><div :class='["modal-footer-slot-with-cancel-demo"]'><cube-modal ref="__mpx_ref_modal__" title="我是标题~" content="我是正文我是正文我是正文我是正文我是正文我是正文" direction="horizontal" cancel-text="取消" :mask-closable="(true)" :no-built-in-btns="(true)"><cube-confirm-button-group slot="footer" type="confirm" @confirm='(e)=>__invoke(e, [["onConfirm"]])'/><div slot="footer" :class='["model-footer"]'>起点不在此机场</div></cube-modal><cube-button @_click="onTap">modal-footer-slot</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_294ebbed"}'>
.modal-footer-slot-with-cancel-demo
  .model-footer
    margin-top 15px
    text-align center
    font-size 16px
    color #757575
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_294ebbed"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_294ebbed"}
  /** script content **/
  require("./modal-footer-slot-with-cancel.mpx.js?isComponent&outputPath=components%2Fmodal-footer-slot-with-cancel294ebbed%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-footer-slot-with-cancel.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-footer-slot-with-cancel294ebbed%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_294ebbed"],
    ctorType: "component",
    outputPath: "components/modal-footer-slot-with-cancel294ebbed/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-confirm-button-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/confirm-button-group/index.mpx?isComponent&outputPath=components%2Findex68efc40c%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>